import { validationRules } from "../../utils/validation";

export const propertyInfoSchema = {
    propertyName: [
        validationRules.required("Property Name is required"),
    ],
    addressLine1: [
        validationRules.required("Address Line 1 is required"),
    ],
    city: [
        validationRules.required("City is required"),
    ],
    country: [
        validationRules.required("Country is required"),
    ],
    postcode: [
        validationRules.required("Postcode is required"),
    ],
}